var React = require('react');

function Roundmail (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"17.5","stroke":"#EEEEEE","strokeOpacity":"0.5","key":0}),React.createElement("path",{"d":"M11.6904 12.6016H24.3094C25.4999 12.6016 26.0999 13.1768 26.0999 14.3468V22.5563C26.0999 23.7166 25.4999 24.3016 24.3094 24.3016H11.6904C10.4999 24.3016 9.8999 23.7166 9.8999 22.5563V14.3468C9.8999 13.1768 10.4999 12.6016 11.6904 12.6016ZM17.9951 20.9866L24.4142 15.5948C24.6428 15.3998 24.8237 14.9513 24.538 14.5516C24.2618 14.1518 23.757 14.1421 23.4237 14.3858L17.9951 18.1493L12.5761 14.3858C12.2428 14.1421 11.738 14.1518 11.4618 14.5516C11.1761 14.9513 11.357 15.3998 11.5856 15.5948L17.9951 20.9866Z","fill":"#EEEEEE","key":1})]);
}

Roundmail.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Roundmail;

Roundmail.default = Roundmail;
